import './App.css'
import Pages from "./pages/index.jsx"

function App() {
  return (
    <>
      <Pages />
    </>
  )
}

export default App 